import { CreateEditFormDrawer } from 'framework/ViewTypes/contentLayout';
import type { FormFieldsData } from 'framework/form';
import type { SourcingFilterOptions, SourcingFilters } from '../../../../types';
import getSettingsSourcingDrawerSections from './SettingsSourcingDrawerSections';
import { getSettingsSourcingDrawerValidationSchemaFunc } from './settingsSourcingDrawerValidation';
import { resolveInitialSourcingFilters } from '../../utils/sourcingFilterModel';
import { SOURCING_FILTERS } from '../../constants';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  filterOptions: SourcingFilterOptions;
  initialFilters: SourcingFilters | undefined;
  onApply: (filters: SourcingFilters) => void;
};

const SettingsSourcingDrawer = ({ isOpen, onClose, filterOptions, initialFilters = {}, onApply }: Props) => {
  return (
    <CreateEditFormDrawer
      key={isOpen ? 'settings-open' : 'settings-closed'}
      isOpen={isOpen}
      onClose={onClose}
      title="Sourcing settings"
      initialData={{
        stricts: [SOURCING_FILTERS.specialization, SOURCING_FILTERS.technology, ...(initialFilters.stricts ?? [])],
        specializationId: initialFilters.specializationId ?? null,
        technologyId: initialFilters.technologyId ?? null,
        levels: initialFilters.levels ?? [],
        skills: initialFilters.skills ?? [],
        englishLevel: initialFilters.englishLevel ?? null,
        location: initialFilters.location ?? [],
        tags: initialFilters.tags ?? [],
        lastInteraction: {
          from: initialFilters.lastInteraction?.from ?? null,
          to: initialFilters.lastInteraction?.to ?? null,
        },
      }}
      isCreateRequest
      handleDirty={false}
      getValidationSchemaFunc={getSettingsSourcingDrawerValidationSchemaFunc(filterOptions)}
      submitButtonTitle="Apply"
      submitFormFunc={async (data: FormFieldsData) => {
        const nextFilters = resolveInitialSourcingFilters(filterOptions, data);
        onApply(nextFilters);
        onClose();
        return nextFilters;
      }}
      getSections={data =>
        getSettingsSourcingDrawerSections({
          data,
          filterOptions,
        })
      }
      width={760}
    />
  );
};

export default SettingsSourcingDrawer;
